// Contratos da API de agência: visão consolidada e marca própria (fatia S5b).
import type { AutopilotMode } from '../domain'

export type AgencyAlertKind = 'connection_broken' | 'over_pace' | 'no_data' | 'autopilot_paused' | 'no_connection'

export interface AgencyAlert {
  kind: AgencyAlertKind
  severity: 'warning' | 'critical'
  message: string
}

export type PaceStatus = 'no_budget' | 'under' | 'on_track' | 'over'

export interface AgencyClientRow {
  companyId: string
  name: string
  segment: string | null
  connections: { active: number; needsReconnect: number }
  /** Valores em reais */
  spendMonth: number
  monthlyBudget: number | null
  /** Gasto previsto para o mês inteiro no ritmo atual */
  projectedSpend: number
  /** gasto ÷ gasto esperado até hoje (1 = no ritmo) */
  paceRatio: number | null
  pace: PaceStatus
  results: number
  costPerResult: number | null
  suggestions: { open: number; high: number }
  autopilot: { mode: AutopilotMode; paused: boolean; pausedReason: string | null }
  lastDataDate: string | null
  alerts: AgencyAlert[]
  /** Maior = precisa de mais atenção */
  attentionScore: number
}

/** GET /agency/:accountId/overview */
export interface AgencyOverviewResponse {
  accountId: string
  accountName: string
  month: string // 'YYYY-MM'
  dayOfMonth: number
  daysInMonth: number
  totals: { companies: number; needingAttention: number; spendMonth: number; monthlyBudget: number; results: number; openSuggestions: number }
  clients: AgencyClientRow[]
}

/** GET /accounts/:accountId/branding */
export interface AccountBrandingResponse {
  displayName: string
  primaryColor: string
  logoUrl: string | null
  /** O plano permite marca própria? */
  available: boolean
  /** Já existe marca salva? */
  configured: boolean
}

/** PUT /accounts/:accountId/branding */
export interface AccountBrandingUpdate {
  displayName: string
  primaryColor: string
}

/** GET /companies/:companyId/branding (BrandMark e portal do cliente) */
export interface CompanyBrandingResponse {
  custom: boolean
  displayName: string
  primaryColor: string
  logoUrl: string | null
}

export const DEFAULT_BRAND = { displayName: 'Seu Impulso', primaryColor: '#5b3df5' } as const
